import { render } from "./AdminBroadcastMonitor.vue?vue&type=template&id=88bac006&scoped=true"
import script from "./AdminBroadcastMonitor.vue?vue&type=script&lang=js"
export * from "./AdminBroadcastMonitor.vue?vue&type=script&lang=js"

import "./AdminBroadcastMonitor.vue?vue&type=style&index=0&id=88bac006&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88bac006"]])

export default __exports__